import React, { useCallback, useEffect, useState } from 'react';
import {
  Form,
  Modal,
  Row,
  InputNumber,
  Col,
  Switch,
  DatePicker,
  Divider,
  Card,
  Tabs,
} from 'antd';
import { FormInstance, useForm } from 'antd/lib/form/Form';
import TextArea from 'antd/lib/input/TextArea';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {
  dateToString,
  shouldUpdateCompare,
  toDatePickerDate,
} from 'utils/utils2';
import FormInput from 'components/FormInput';
import { toCurrency, toRate } from '../../../utils/utils';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ParListSelect from 'components/ParListSelect';
import { AssetComponent } from 'services/assets';
import Value from 'components/Value';
import TaxSelect from 'components/TaxSelect';
import GetLabel from 'DisplayFramework/components/GetLabel';
import InputCurrency from 'components/InputCurrency';
import InputRate from 'components/InputRate';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import FormItem from 'antd/lib/form/FormItem';
import { sumBy } from 'lodash';
import _ from 'lodash';

export type AssetCatalogComponentModalProps = {
  formC: FormInstance;
  addorupdate: 'ADD' | 'UPDATE';
  visible: boolean;
  onCancel: () => void;
  onOk: (item: AssetComponent) => void;
  currcode: string;
  compid?: number;
  record?: any;
  linkedCon?: boolean;
  status?: string;
  catalogid?:number
};
const { TabPane } = Tabs;
const initialValues = {
  compid: -1,
  suppliername: '',
  supplierreference: '',
  comptype: 'ASSET',
  compcategory: '',
  compdescription: '',
  comporiginalnetamount: 0,
  compdiscountrate: 0,
  compnetamount: 0,
  taxcode: '',
  taxrate: 0,
  comptaxamount: 0,
  compgrossamount: 0,
  asset: null as any,
  compdiscountamount: 0,
  compfree1: '',
  tpidsupplier: 0,
  flagholdback: false,
  holdbackpercentage: 0,
  holdbackamount: 0,
  holdbackbeleasenbdays: 0,
  holdbackbeleasedate: '',
  catalogidtarget: '' as any,
  catalogidtargetlabel: '',
};

const AssetCatalogComponentsTableModal = (
  props: AssetCatalogComponentModalProps
) => {
  const {
    visible,
    onCancel,
    onOk,
    addorupdate,
    formC,
    compid,
    currcode,
    record,
    linkedCon,
    status,
    catalogid
  } = props;

  const [form] = useForm();
  const recalculate = useCallback(
    (updatedValues: any) => {
      let comporiginalnetamount = form.getFieldValue('comporiginalnetamount');
      let compdiscountrate = form.getFieldValue('compdiscountrate');
      let taxrate =
        updatedValues?.taxrate !== undefined
          ? updatedValues?.taxrate
          : form.getFieldValue('taxrate') ?? 0;
      let compnetamount =
        comporiginalnetamount -
        comporiginalnetamount * (compdiscountrate / 100);
      let comptaxamount = compnetamount * (taxrate / 100);
      let compgrossamount = compnetamount + comptaxamount;
      form.setFieldsValue({
        taxrate: taxrate,
        comporiginalnetamount: comporiginalnetamount,
        compdiscountrate: compdiscountrate,
        compnetamount: compnetamount,
        comptaxamount: comptaxamount,
        compgrossamount: compgrossamount,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formC]
  );
  const [disabl, setdisabl] = useState(Boolean);
  useEffect(() => {
    if (addorupdate === 'UPDATE') {
      if (record?.assetcompschedule?.length > 0)
        form.setFieldsValue({
          totalHoldBackAmount: sumBy(
            record?.assetcompschedule,
            'holdbackamount'
          ),
          assetscheduledamount: sumBy(record?.assetcompschedule, 'payamount'),
          compassetschedules: record?.assetcompschedule?.map((ele: any) => ({
            ...ele,
            holdbackprevreleasedate: toDatePickerDate(
              ele.holdbackprevreleasedate
            ),
            holdbackreleasedate: toDatePickerDate(ele.holdbackreleasedate),
            paydate: toDatePickerDate(ele.paydate),
            payduedate: toDatePickerDate(ele.payduedate),
            previsionalduedate: toDatePickerDate(ele.previsionalduedate),
            action: 'UPDATE',
          })),
        });
      form.setFieldsValue({
        compid: record?.compid,
        suppliername: record?.suppliername,
        supplierreference: record?.supplierreference,
        comptype: record?.comptype,
        compcategory: record?.compcategory,
        compdescription: record?.compdescription,
        comporiginalnetamount: record?.comporiginalnetamount,
        compdiscountrate: record?.compdiscountrate,
        compnetamount: record?.compnetamount,
        taxcode: record?.taxcode,
        taxrate: record?.taxrate,
        comptaxamount: record?.comptaxamount,
        compgrossamount: record?.compgrossamount,
        asset: record?.asset,
        compdiscountamount: record?.compdiscountamount,
        compfree1: record?.compfree1,
        tpidsupplier: record?.tpidsupplier,
        flagholdback: record?.flagholdback,
        holdbackpercentage: record?.holdbackpercentage,
        holdbackamount: record?.holdbackamount,
        holdbackbeleasenbdays: record?.holdbackbeleasenbdays,
        holdbackbeleasedate: toDatePickerDate(record?.holdbackbeleasedate),
        supplier: {
          tpid: record?.tpidsupplier,
          tpname: record?.suppliername,
          tpreference: record?.supplierreference,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  const handleFinish = (values: any) => {
    onOk({
      ...values,
      compid:
        addorupdate === 'ADD' ? Math.round(_.random(10000000)) : compid,
      suppliername: values?.supplier?.tpname,
      supplierreference: values?.supplier?.tpreference,
      tpidsupplier: values?.supplier?.tpid,
      holdbackbeleasedate: dateToString(values?.holdbackbeleasedate ?? ''),
    });
    form.resetFields();
  };
  return (
    <Modal
      visible={visible}
      title={
        addorupdate === 'ADD' ? (
          <GetLabel label="AddAssetComponent" />
        ) : (
          <GetLabel label="updateAssetComponent" />
        )
      }
      onOk={() => form.submit()}
      okText="Add"
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      width="1200px"
      style={{ top: 20 }}
    >
      <Card>
        <Form
          form={form}
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          initialValues={initialValues}
          labelCol={{ span: 24 }}
        >
          <Row gutter={16}>
            <Col span={16}>
              <Row gutter={16}>
                <FormInput
                  rules={[{ required: true }]}
                  comcode="comptype"
                  name="comptype"
                  col
                  xs={12}
                  shouldUpdate
                >
                  <ParListSelect
                    parcode="COMPTYPE"
                    disabled={
                      linkedCon ||
                      status === 'PROPOSAL' ||
                      status === 'ORDER' ||
                      status === 'DELIVER'
                    }
                  />
                </FormInput>
                <Form.Item
                  rules={[{ required: true }]}
                  shouldUpdate={shouldUpdateCompare('comptype')}
                  noStyle
                >
                  {({ getFieldValue }) => (
                    <FormInput
                      comcode="compcategory"
                      col
                      xs={12}
                      name="compcategory"
                      rules={[{ required: true }]}
                    >
                      <ParListSelect
                        parcode="COMPCAT"
                        parvalueparent={getFieldValue('comptype')}
                        disabled={
                          linkedCon ||
                          status === 'PROPOSAL' ||
                          status === 'ORDER' ||
                          status === 'DELIVER'
                        }
                      />
                    </FormInput>
                  )}
                </Form.Item>
              </Row>
              {/* <Row>
                <Form.Item
                  rules={[{ required: true }]}
                  shouldUpdate={shouldUpdateCompare('compcategory')}
                  noStyle
                >
                  {({ getFieldValue }) =>
                    getFieldValue('compcategory') === 'ASSET' ? (
                      <FormInput
                        comcode="catalogidtarget"
                        col
                        xs={12}
                        name="catalogidtarget"
                      >
                        <AssetCatalogInput
                          onChange={(e: any) => {
                            if (e.catalogid===catalogid){
                              notification.error({message:"you can't add the current asset"});
                              
                            }else {
                            form.setFieldsValue({
                              comporiginalnetamount: e.assetnetamountorigine,
                              compdiscountrate: e.assetdiscountperc,
                            });
                            setdisabl(true);
                          }}}
                        />
                      </FormInput>
                    ) : null
                  }
                </Form.Item>
              </Row> */}
              <Row>
                <FormInput
                  col
                  xs={24}
                  rules={[{ required: true }]}
                  name="supplier"
                >
                  <ThirdPartyInput
                    role="SUPPLIER"
                    display={
                      status === 'PROPOSAL' ||
                      status === 'ORDER' ||
                      status === 'DELIVER'
                    }
                  />
                </FormInput>

                <FormInput
                  col
                  xs={24}
                  name="compdescription"
                  comcode="compdescription"
                  rules={[{ required: true }]}
                >
                  <TextArea
                    rows={7}
                    disabled={
                      status === 'PROPOSAL' ||
                      status === 'ORDER' ||
                      status === 'DELIVER'
                    }
                  />
                </FormInput>
              </Row>
            </Col>
            <Col span={8}>
              <Card type="inner" style={{ background: '#F6F3F2' }}>
                <Row gutter={16}>
                  <Form.Item noStyle shouldUpdate>
                    <InputCurrency
                      col
                      md={12}
                      onChange={(value) =>
                        recalculate({ comporiginalnetamount: value })
                      }
                      currcode={currcode}
                      fieldname="comporiginalnetamount"
                      comcode="comporiginalnetamount"
                      rules={[{ required: true }]}
                      disabled={
                        disabl ||
                        linkedCon ||
                        status === 'PROPOSAL' ||
                        status === 'ORDER' ||
                        status === 'DELIVER'
                      }
                    />
                  </Form.Item>
                  <Form.Item noStyle shouldUpdate>
                    <FormInput
                      col
                      xs={12}
                      name="compdiscountrate"
                      comcode="compdiscountrate"
                      shouldUpdate
                    >
                      <InputNumber
                        min={0}
                        max={100}
                        formatter={(value) => `${value}%`}
                        onChange={(value) =>
                          recalculate({ discountRate: value })
                        }
                        disabled={
                          disabl ||
                          linkedCon ||
                          status === 'PROPOSAL' ||
                          status === 'ORDER' ||
                          status === 'DELIVER'
                        }
                      />
                    </FormInput>
                  </Form.Item>

                  <FormInput
                    col
                    xs={12}
                    name="compnetamount"
                    comcode="compnetamount"
                  >
                    <Value formatter={(value) => toCurrency(value, currcode)} />
                  </FormInput>
                  <FormInput
                    name="taxcode"
                    col
                    xs={12}
                    shouldUpdate
                    comcode="comptaxcode"
                    rules={[{ required: true }]}
                  >
                    <TaxSelect
                      taxflow="INOUT"
                      disabled={
                        linkedCon ||
                        status === 'PROPOSAL' ||
                        status === 'ORDER' ||
                        status === 'DELIVER'
                      }
                      onSelected={(tax) =>
                        recalculate({ taxrate: tax?.taxrate })
                      }
                    />
                  </FormInput>

                  <FormInput
                    col
                    xs={24}
                    md={12}
                    name="comptaxamount"
                    comcode="comptaxamount"
                  >
                    <Value formatter={(value) => toCurrency(value, currcode)} />
                  </FormInput>
                  <FormInput
                    col
                    xs={24}
                    md={12}
                    name="compgrossamount"
                    comcode="compgrossamount"
                  >
                    <Value formatter={(value) => toCurrency(value, currcode)} />
                  </FormInput>
                  <FormInput
                    col
                    xs={12}
                    name="taxrate"
                    comcode="comptaxrate"
                    hidden
                  >
                    <Value formatter={toRate} />
                  </FormInput>
                </Row>
              </Card>
            </Col>
          </Row>
          <Divider></Divider>
          <Row gutter={16}>
            <FormInput col xs={3} name="flagholdback" valuePropName="checked">
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                disabled={
                  status === 'PROPOSAL' ||
                  status === 'ORDER' ||
                  status === 'DELIVER'
                }
              />
            </FormInput>
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) =>
                getFieldValue('flagholdback') ? (
                  <>
                    <FormInput col xs={24} md={4} name="holdbackpercentage">
                      <InputRate
                        disabled={
                          status === 'PROPOSAL' ||
                          status === 'ORDER' ||
                          status === 'DELIVER'
                        }
                      ></InputRate>
                    </FormInput>
                    <FormInput col xs={24} md={6} name="holdbackamount">
                      <InputCurrency
                        currcode={form.getFieldValue('currcode')}
                        disabled={
                          status === 'PROPOSAL' ||
                          status === 'ORDER' ||
                          status === 'DELIVER'
                        }
                      ></InputCurrency>
                    </FormInput>
                    <FormInput col xs={24} md={3} name="holdbackbeleasenbdays">
                      <InputNumber
                        disabled={
                          status === 'PROPOSAL' ||
                          status === 'ORDER' ||
                          status === 'DELIVER'
                        }
                      ></InputNumber>
                    </FormInput>
                    <FormInput col xs={24} md={6} name="holdbackbeleasedate">
                      <DatePicker
                        disabled={
                          status === 'PROPOSAL' ||
                          status === 'ORDER' ||
                          status === 'DELIVER'
                        }
                      ></DatePicker>
                    </FormInput>
                  </>
                ) : null
              }
            </FormItem>
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default AssetCatalogComponentsTableModal;
